import Vue from "vue"
export default {
    name: "navigation-menu",
    props: ['drawer','closeMenu'],
    data () {
      return {
        items: [
          { title: 'Home', icon: 'mdi-view-dashboard' },
          { title: 'About', icon: 'mdi-forum' },
        ],
      }
    },
    computed: {
        mini() {
            return (this.$vuetify.breakpoint.smAndDown) || this.toggleMini
        }
    },
    created: function () {
        this.fetchMenuItems();
    },
    methods: {
        fetchMenuItems: function () {
            this.items = this.$store.getters["menu"];
        },
        handleRoute: function (item) {
          debugger;
          this.closeMenu()
            if (this.$route.path !== item.path||item.path.includes("microui")) {
           
              if (item.path.includes("microui")) {     
             
                this.$eventHub.$emit("plateau", "1");

               var pageId = window.plateau_ui.open(item.path);}
               else{
               this.$eventHub.$emit("plateau", "0");
                           
                this.$router.push({
                  path: item.path
                });
               }
             
              
            }
            
        },
        isMenuItem: function(collection){
            return collection.filter(x => x.menuItem == true);
        },
    },
    watch: { 
      drawer: function(newVal, oldVal) { // watch it
        console.log(newVal, oldVal);
        if(!newVal) {
          this.closeMenu()
        }
      }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixin/NavigationMenu.js